class ModuleSearch {
  constructor(type) {
    this.inputType = type;
    this.input = document.querySelector(`.js-module-search-${this.inputType}`);
    this.blocks = document.querySelectorAll(`.js-module-block-${this.inputType}`);
    this.noResults = document.querySelector(`.js-empty-message-${this.inputType}`);
    this.clearBtn = document.querySelector(`.js-module-search-clear-${this.inputType}`);
    this.registerEvents();
  }

  registerEvents() {
    if (this.clearBtn) {
      this.input.addEventListener('keyup', (e) => {
        this.showHideBlocks();
        this.showHideClear();
      });
    }
    this.clearBtn.addEventListener('click', () => {
      this.clearInput();
      this.showHideClear();
      this.showHideBlocks();
    });
  }

  showHideBlocks() {
    this.blocks.forEach(block => {
      const targets = block.querySelectorAll('.js-module-row');
      const blockValue = block.dataset.groupName;
      let allRowsHidden = true;
      targets.forEach(target => {
        const value = target.dataset.tableName;
        const rawValue = target.dataset.tableRawName || '';
        const query = this.input.value.toUpperCase();
        if (value) {
          target.style.display =
            value.toUpperCase().indexOf(query) > -1 ||
            rawValue.toUpperCase().indexOf(query) > -1 ||
            blockValue.toUpperCase().indexOf(query) > -1
              ? ''
              : 'none';
        }
        // hide blocks if all children are hidden
        if (target.style.display !== 'none') allRowsHidden = false;
      });
      block.style.display = allRowsHidden ? 'none' : '';
    });
    // show message if all blocks are hidden
    let allBlocksHidden = true;

    for (let block of this.blocks) {
      if (block.style.display !== 'none') allBlocksHidden = false;
    }
    this.noResults.style.display = allBlocksHidden ? '' : 'none';
  };

  setBlocksHidden() {
    let allBlocksHidden = true;
    for (let block of blocks) {
      if (block.style.display !== 'none') allBlocksHidden = false;
    }
    this.noResults.style.display = allBlocksHidden ? '' : 'none';
  };

  showHideClear() {
    if (this.clearBtn) {
      this.input.value
        ? this.clearBtn.classList.add('show')
        : this.clearBtn.classList.remove('show');
    }
  };

  clearInput() {
    this.input.value = '';
    this.input.focus();
  };
}

export default ModuleSearch



// WEBPACK FOOTER //
// ./resources/assets/js/components/search/ModuleSearch.js